import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { formatAddress } from "../../utils/formatAddress";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";

import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TocIcon from "@mui/icons-material/Toc";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { CreateNewAccountModal } from "../TableModal";
import api from "../../api/axios";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/pt-br";
// import { CreateNewOcurrencesModal } from "../OcurrencesModal";
import { formatAcademicLevel } from "../../utils/formatAcademicLevel";
import { CreateNewBlankModal } from "../BlankModal";
import { Article, Delete, PersonRemove } from "@mui/icons-material";
import PersonIcon from "@mui/icons-material/Person";
import EditIcon from "@mui/icons-material/Edit";
import { EditCooperativeModal } from "../EditCooperativeModal";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { ButtonText } from "./styled";
import { toast } from "react-toastify";
import { EditSkillModal } from "../EditSkillModal";
import { ProfessionalOccurrencesModal } from "../ProfessionalOccurrencesModal";
import { OccurrenceFilesModal } from "../OccurrenceFilesModal";
import { ProfessionalDocsModal } from "../ProfessionalDocsModal";
import FullScreenLoader from "../FullScreenLoader";

export const Table = ({
  tableSectionRef,
  professionalData,
  tableData,
  setTableData,
  tableType,
  setTableType,
  getData,
}) => {
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [infoModal, setInfoModal] = useState({
    type: "",
    data: [],
  });
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  const [occurrence, setOccurrence] = useState(null);
  const [ocurrencesModalOpen, setOccurrencesModalOpen] = useState(false);
  const [occurrencesModalType, setOccurrencesModalType] = useState("create");

  const [occurrenceFiles, setOccurrenceFiles] = useState(null);
  const [occurrenceFilesModalOpen, setOccurrenceFilesModalOpen] =
    useState(false);

  const [occurrenceBackTo, setOccurrenceBackTo] = useState("professional");
  const [occurenceIsGoingBack, setOccurrenceIsGoingBack] = useState(false);

  const [oportunities, setOportunities] = useState([]);
  const [allApplications, setAllApplications] = useState([]);

  const [cooperative, setCooperative] = useState({});
  const [cooperativeModalMode, setCooperativeModalMode] = useState("create");
  const [cooperativeEditModal, setCooperativeEditModal] = useState(false);

  const [skill, setSkill] = useState({});
  const [skillModalMode, setSkillModalMode] = useState("create");
  const [skillEditModal, setSkillEditModal] = useState(false);

  const [professional, setProfessional] = useState(null);

  const [professionalDocsModalOpen, setProfessionalDocsModalOpen] =
    useState(false);

  const [rowSelection, setRowSelection] = useState({});

  const [pageState, setPageState] = useState({
    selectedTable: "",
    filters: [],
    scrollY: 0,
  });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [sorting, setSorting] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({ _id: false });
  const [highlightedRowId, setHighlightedRowId] = useState(null);

  const [allOccurrences, setAllOccurrences] = useState([]);

  const [isDownloading, setIsDownloading] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const tableInstanceRef = useRef(null);
  const restoredStateRef = useRef(false);

  const navigate = useNavigate();

  const getAllOccurrences = async () => {
    try {
      const { data } = await api.get(`/professional_occurrence/list`);
      setAllOccurrences(data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  const getOccurrences = async (id) => {
    try {
      const { data } = await api.get(
        `/professional_occurrence/get-by-professional/${id}`,
      );
      setTableData(data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  const getOportunities = async (id) => {
    try {
      const { data } = await api.get(`/application/get-by-professional/${id}`);
      setOportunities(data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  const getAllApplications = async () => {
    try {
      const { data } = await api.get(`/application/list-pop`);
      setAllApplications(data);
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }
  };

  const handleBackButton = async () => {
    setOccurrenceIsGoingBack(true);
    await getData(occurrenceBackTo);
    setOccurrenceIsGoingBack(false);
  };

  const handleCloseOcurrences = async () => {
    setOccurrence(null);
    setOccurrencesModalOpen(false);
    setOccurrencesModalType("create");
  };

  const handleOpenMoreInfo = (row, type) => {
    setInfoModal({
      type,
      data:
        type === "courses" ? row.original.courses : row.original.experiences,
    });
    setInfoModalOpen(true);
  };

  const handleCloseMoreInfo = async () => {
    setInfoModal({
      type: "",
      data: [],
    });
    setInfoModalOpen(false);
  };

  const handleEditCooperativeClick = (row) => {
    setCooperative(row.original);
    setCooperativeModalMode("edit");
    setCooperativeEditModal(true);
  };

  const closeEditCooperativeModal = () => {
    setCooperative({});
    setCooperativeEditModal(false);
    getData("cooperative");
  };

  const handleCreateSkillClick = () => {
    setSkillModalMode("create");
    setSkillEditModal(true);
  };

  const handleEditSkillClick = (row) => {
    setSkill(row.original);
    setSkillModalMode("edit");
    setSkillEditModal(true);
  };

  const closeEditSkillModal = () => {
    setSkill({});
    setSkillEditModal(false);
    setSkillModalMode("create");
    getData("skill");
  };

  const handleCreateOccurrenceClick = () => {
    setOccurrencesModalType("create");
    setOccurrencesModalOpen(true);
  };

  const handleEditOccurrenceClick = (row) => {
    setOccurrence(row.original);
    setOccurrencesModalType("edit");
    setOccurrencesModalOpen(true);
  };

  const handleViewOccurenceFilesClick = (row) => {
    setOccurrenceFiles(row.original);
    setOccurrenceFilesModalOpen(true);
  };

  const handleCloseOcurrencesFiles = () => {
    setOccurrenceFiles(null);
    setOccurrenceFilesModalOpen(false);
  };

  const closeCreateCooperativeModal = () => {
    setProfessional(null);
    setCreateModalOpen(false);
  };

  const closeProfessionalDocsModal = () => {
    setProfessionalDocsModalOpen(false);
  };

  const handleAnalyzeSkillsClick = async () => {
    try {
      setIsAnalyzing(true);

      const skillsToAnalyze = selectedRows.map((row) => row.name);

      const res = await api.post(
        "/professional/analyze-all-curriculums",
        skillsToAnalyze.length > 0 ? { skills: skillsToAnalyze } : {},
      );

      toast.success(res.data.message);
      toast.success(
        `Profissionais analizados: ${res.data.analyzed}\nProfissionais atualizados: ${res.data.updated}\nHabilidades adicionadas: ${res.data.skillsAdded}`,
        { autoClose: 10000, delay: 1000 },
      );
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro ao analizar os currículos");
    } finally {
      setIsAnalyzing(false);
    }
  };

  const handleEditProfessionalClick = (row, table) => {
    const professionalIds =
      table
        ?.getPrePaginationRowModel()
        ?.rows?.map((tableRow) => tableRow.original.user._id) || [];

    sessionStorage.setItem(
      "adminPageState",
      JSON.stringify({
        ...pageState,
        selectedTable: tableType,
        scrollY: tableSectionRef.current?.scrollTop || 0,
        pagination,
        sorting,
        columnVisibility,
        selectedProfessionalId: row.original._id,
        professionalIds,
      }),
    );

    navigate(
      `/editar-profissional/${row.original.user._id}?email=${row.original.user.email}`,
    );
  };

  const handleViewProfessionalClick = (row) => {
    sessionStorage.setItem(
      "adminPageState",
      JSON.stringify({
        ...pageState,
        selectedTable: tableType,
        scrollY: tableSectionRef.current?.scrollTop || 0,
        pagination,
        sorting,
        columnVisibility,
        selectedProfessionalId: row.original._id,
      }),
    );

    const userId = professionalMap[row.original.professional]?.user?._id;
    navigate(`/editar-profissional/${userId}`);
  };

  const handleEndClick = async (row) => {
    try {
      await api.put(`/cooperative/update/${row.original._id}`, {
        end_date: new Date(),
      });
      getData("cooperative");
      toast.success("Vigência encerrada");
    } catch (err) {
      toast.error("Ocorreu um erro ao encerrar a vigência");
      console.error(err);
    }
  };

  const professionalMap = useMemo(() => {
    const map = {};
    professionalData?.forEach((p) => {
      map[p._id] = {
        ...p,
      };
    });
    return map;
  }, [professionalData]);

  const getCommonEditTextFieldProps = useCallback(
    (cell) => {
      return {
        error: !!validationErrors[cell.id],
        helperText: validationErrors[cell.id],
        onBlur: (event) => {
          const isValid =
            cell.column.id === "nome"
              ? validateRequired(event.target.value)
              : true;
          if (!isValid) {
            setValidationErrors({
              ...validationErrors,
              [cell.id]: `${cell.column.columnDef.header} is required`,
            });
          } else {
            delete validationErrors[cell.id];
            setValidationErrors({
              ...validationErrors,
            });
          }
        },
      };
    },
    [validationErrors],
  );

  const handleCreateNewRow = async (values) => {
    delete values._id;

    try {
      await api.post("/cooperative/create", values);
      // setTableData((prev) => [...prev, res.data]);
      await getData("cooperative");
    } catch (err) {
      toast.error(err);
    }
  };

  const handleDeleteRow = async (row) => {
    setCooperative(row.original);
    setCooperativeModalMode("delete");
    setCooperativeEditModal(true);
  };

  const handleDeleteSkill = async (row) => {
    setSkill(row.original);
    setSkillModalMode("delete");
    setSkillEditModal(true);
  };

  const handleDeleteOccurrence = async (row) => {
    setOccurrence(row.original);
    setOccurrencesModalType("delete");
    setOccurrencesModalOpen(true);
  };

  const handleAddCooperativeClick = async (row) => {
    setProfessional(row.original._id);
    setCreateModalOpen(true);
  };

  const lastOccurrencesByProfessional = useMemo(() => {
    const occurrencesMap = {};

    allOccurrences.forEach((occurrence) => {
      const professionalId =
        typeof occurrence.professional === "object"
          ? occurrence.professional._id
          : occurrence.professional;

      if (!professionalId) return;

      if (
        !occurrencesMap[professionalId] ||
        new Date(occurrence.date) >
          new Date(occurrencesMap[professionalId].date)
      ) {
        occurrencesMap[professionalId] = occurrence;
      }
    });

    return occurrencesMap;
  }, [allOccurrences]);

  const professionalColumns = useMemo(
    () => [
      {
        accessorKey: "_id",
        header: "ID",
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: false,
        enableHiding: false,
        size: 80,
      },
      {
        accessorKey: "name",
        header: "Nome",
        size: 250,
        filterFn: "includesString",
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        id: "lastAction",
        header: "Última Ação",

        accessorFn: (row) => {
          const lastOccurrence = lastOccurrencesByProfessional[row._id];

          if (!lastOccurrence) {
            return "Sem Ações";
          }

          let op = null;

          if (lastOccurrence.oportunity) {
            op = allApplications.find(
              (item) => item._id === lastOccurrence.oportunity,
            );
          }

          const date = new Date(lastOccurrence.date).toLocaleDateString(
            "pt-BR",
          );

          const opportunityText = op
            ? ` ${op.oportunity?.cargo} (${op.oportunity?.empresa})`
            : "";

          return `${lastOccurrence.title} - ${date}${opportunityText}`;
        },

        filterFn: "includesString",

        size: 400,

        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),

        Cell: ({ row }) => {
          const lastOccurrence =
            lastOccurrencesByProfessional[row.original._id];

          if (!lastOccurrence) {
            return <span style={{ fontSize: 13 }}>Sem Ações</span>;
          }

          let op = null;

          if (lastOccurrence.oportunity) {
            op = allApplications.find(
              (item) => item._id === lastOccurrence.oportunity,
            );
          }

          return (
            <div style={{ fontSize: 13 }}>
              <div>
                {`${lastOccurrence.title} - ${new Date(
                  lastOccurrence.date,
                ).toLocaleDateString("pt-BR")}`}
              </div>

              {op && (
                <div>
                  <span style={{ fontSize: "0.75rem" }}>
                    {`${op.oportunity?.cargo} (${op.oportunity?.empresa})`}
                  </span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        accessorFn: (row) =>
          Array.isArray(row.skills) ? row.skills.join(", ") : "",
        id: "skills",
        header: "Habilidades",
        filterFn: "includesString",
        size: 250,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
      },
      {
        accessorKey: "cpf",
        header: "CPF",
        filterFn: "includesString",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorFn: (row) => row.user?.email,
        id: "email",
        header: "E-mail",
        filterFn: "includesString",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorKey: "phone",
        header: "Telefone",
        filterFn: "includesString",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => {
          const formatted =
            renderedCellValue?.length === 11
              ? `(${renderedCellValue.slice(0, 2)}) ${renderedCellValue.slice(
                  2,
                  7,
                )}-${renderedCellValue.slice(7)}`
              : renderedCellValue;

          return <span style={{ fontSize: 13 }}>{formatted}</span>;
        },
      },
      {
        accessorFn: (row) => formatAddress(row.address),
        id: "address",
        header: "Endereço",
        filterFn: "includesString",
        size: 400,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorFn: (row) => new Date(row.registerDate),
        id: "registerDate",
        header: "Data do Registro",
        filterFn: "includesString",
        size: 70,

        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),

        Cell: ({ cell }) => (
          <span style={{ fontSize: 13 }}>
            {cell.getValue()?.toLocaleDateString("pt-BR")}
          </span>
        ),
      },

      {
        accessorFn: (row) =>
          row.academicLevel?.educationLevel &&
          !row.academicLevel?.educationLevel.includes("Ensino Médio")
            ? formatAcademicLevel(row.academicLevel)
            : row.academicLevel?.educationLevel,
        id: "academicLevel",
        header: "Formação",
        filterFn: "includesString",
        size: 300,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorKey: "courses",
        header: "Cursos/Outras Formações",
        size: 140,
        enableColumnFilter: false,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ row }) => (
          <Button
            onClick={() => handleOpenMoreInfo(row, "courses")}
            variant="text"
            sx={{ color: "#104467", fontWeight: 600 }}
          >
            Visualizar
          </Button>
        ),
      },
      {
        accessorKey: "experiences",
        header: "Experiências",
        size: 140,
        enableColumnFilter: false,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ row }) => (
          <Button
            onClick={() => handleOpenMoreInfo(row, "experiences")}
            variant="text"
            sx={{ color: "#104467", fontWeight: 600 }}
          >
            Visualizar
          </Button>
        ),
      },
      {
        accessorKey: "occurrences",
        header: "Ocorrências",
        enableColumnFilter: false,
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ row }) => (
          <Button
            onClick={() => {
              setOccurrenceBackTo("professional");
              setTableType("occurrences");
              // setTableData(row.original.occurrences);
              setProfessional(row.original);
              getOccurrences(row.original._id);
            }}
            variant="text"
            sx={{ color: "#104467", fontWeight: 600 }}
          >
            Visualizar
          </Button>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      getCommonEditTextFieldProps,
      allApplications,
      lastOccurrencesByProfessional,
    ],
  );

  const cooperativeColumns = useMemo(
    () => [
      {
        accessorKey: "_id",
        header: "ID",
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: false,
        enableHiding: false,
        size: 80,
      },
      {
        accessorFn: (row) => {
          return row.professional?.name || "Desconhecido";
        },
        id: "professional",
        header: "Profissional",
        filterFn: "includesString",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ cell }) => {
          return <span style={{ fontSize: 13 }}>{cell.getValue()}</span>;
        },
      },
      {
        accessorKey: "registration",
        header: "Número de matrícula",
        filterFn: "includesString",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        id: "lastActionCoop",
        header: "Última Ação",

        accessorFn: (row) => {
          const lastOccurrence =
            lastOccurrencesByProfessional[row.professional?._id];

          if (!lastOccurrence) {
            return "Sem Ações";
          }

          let op = null;

          if (lastOccurrence.oportunity) {
            op = allApplications.find(
              (item) => item._id === lastOccurrence.oportunity,
            );
          }

          const date = new Date(lastOccurrence.date).toLocaleDateString(
            "pt-BR",
          );

          const opportunityText = op
            ? ` ${op.oportunity?.cargo} (${op.oportunity?.empresa})`
            : "";

          return `${lastOccurrence.title} - ${date}${opportunityText}`;
        },

        filterFn: "includesString",

        size: 400,

        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),

        Cell: ({ row }) => {
          const lastOccurrence =
            lastOccurrencesByProfessional[row.original.professional?._id];

          if (!lastOccurrence) {
            return <span style={{ fontSize: 13 }}>Sem Ações</span>;
          }

          let op = null;

          if (lastOccurrence.oportunity) {
            op = allApplications.find(
              (item) => item._id === lastOccurrence.oportunity,
            );
          }

          return (
            <div style={{ fontSize: 13 }}>
              <div>
                {`${lastOccurrence.title} - ${new Date(
                  lastOccurrence.date,
                ).toLocaleDateString("pt-BR")}`}
              </div>

              {op && (
                <div>
                  <span style={{ fontSize: "0.75rem" }}>
                    {`${op.oportunity?.cargo} (${op.oportunity?.empresa})`}
                  </span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: "profession",
        header: "Profissão",
        filterFn: "includesString",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorFn: (row) => new Date(row.start_date).toLocaleDateString(),
        id: "start_date",
        header: "Início de vigência",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorFn: (row) =>
          row.end_date ? new Date(row.end_date).toLocaleDateString() : "-",
        id: "end_date",
        header: "Fim de vigência",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorFn: (row) =>
          professionalMap[row.professional]?.occurrences || "Desconhecido",
        header: "Ocorrências",
        enableColumnFilter: false,
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ row }) => (
          <Button
            onClick={() => {
              setOccurrenceBackTo("cooperative");
              setTableType("occurrences");
              // setTableData(row.original.occurrences);
              setProfessional(row.original.professional);
              getOccurrences(row.original.professional._id);
            }}
            variant="text"
            sx={{ color: "#104467", fontWeight: 600 }}
          >
            Visualizar
          </Button>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [getCommonEditTextFieldProps, professionalMap],
  );

  const skillColumns = useMemo(
    () => [
      {
        accessorKey: "_id",
        header: "ID",
        enableColumnOrdering: false,
        enableEditing: false,
        enableSorting: false,
        enableHiding: false,
        size: 80,
      },
      {
        accessorKey: "name",
        header: "Nome",
        size: 140,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
    ],
    [getCommonEditTextFieldProps],
  );

  const occurrencesColumns = useMemo(
    () => [
      {
        accessorKey: "title",
        header: "Título",
        size: 30,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorKey: "oportunity",
        header: "Oportunidade",
        size: 200,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => {
          const op = oportunities.find(
            (item) => item._id === renderedCellValue,
          );
          return (
            <span style={{ fontSize: 13 }}>
              {op
                ? `${op?.oportunity?.cargo} (${op?.oportunity?.empresa})`
                : renderedCellValue || "Nenhuma"}
            </span>
          );
        },
      },
      {
        accessorKey: "description",
        header: "Descrição",
        size: 200,
        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),
        Cell: ({ renderedCellValue }) => (
          <span style={{ fontSize: 13 }}>{renderedCellValue}</span>
        ),
      },
      {
        accessorFn: (row) => new Date(row.date),
        id: "date",
        header: "Data da Ocorrência",
        size: 10,

        muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
          ...getCommonEditTextFieldProps(cell),
        }),

        Cell: ({ cell }) => (
          <span style={{ fontSize: 13 }}>
            {cell.getValue()?.toLocaleDateString("pt-BR")}
          </span>
        ),
      },
    ],
    [getCommonEditTextFieldProps, oportunities],
  );

  const formatExportData = (data) => {
    return data.map((item) => {
      const {
        _id,
        __v,
        address,
        user,
        academicLevel,
        courses,
        experiences,
        skills,
        occurrences,
        professional,
        ...rest
      } = item;

      if (tableType === "cooperative") {
        return {
          Nome: professionalMap[professional]?.name || "Desconhecido",
          "Data de Início": item.start_date
            ? new Date(item.start_date).toLocaleDateString("pt-BR")
            : "",
          "Data de Fim": item.end_date
            ? new Date(item.end_date).toLocaleDateString("pt-BR")
            : "",
          Ocorrências: Array.isArray(occurrences)
            ? occurrences
                .map(
                  (o) =>
                    `${new Date(o.date).toLocaleDateString("pt-BR")}: ${
                      o.title
                    } - ${o.description}`,
                )
                .join(" | ")
            : "",
        };
      }

      if (tableType === "professional") {
        return {
          Nome: item.name,
          CPF: item.cpf,
          Telefone: item.phone,
          Endereço: address ? formatAddress(address) : "",
          Formação:
            academicLevel?.educationLevel === "Ensino Superior completo"
              ? formatAcademicLevel(academicLevel)
              : academicLevel?.educationLevel,
          "Cursos/Outras Formações": Array.isArray(courses)
            ? courses
                .map(
                  (c) =>
                    `${c.course} (${c.year}) - ${c.origin}, ${c.duration}, ${c.type}, ${c.deliveryMode}`,
                )
                .join(" | ")
            : "",
          Experiências: Array.isArray(experiences)
            ? experiences
                .map(
                  (e) =>
                    `${e.role} em ${e.local} [Habilidades e Ferramentas: ${e.technologies}]`,
                )
                .join(" | ")
            : "",
          Habilidades: Array.isArray(skills) ? skills.join(", ") : "",
        };
      }

      return rest;
    });
  };

  const handleExportData = () => {
    const dataToExport = formatExportData(tableData);

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const filename = `${
      tableType === "professional" ? "Profissionais" : "Cooperados"
    }_${new Date().toLocaleDateString("pt-BR")}.xlsx`;

    saveAs(data, filename);
  };

  const handleDownloadCurriculums = async () => {
    setIsDownloading(true);

    const professionalIds = selectedRows.map((row) => row._id).filter(Boolean);

    if (!professionalIds.length) {
      return;
    }

    try {
      const response = await api.post(
        "/professional/download-curriculums",
        {
          professionalIds,
        },
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/zip",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;
      link.download = "curriculos.zip";

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erro ao baixar currículos:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const selectedRows = useMemo(() => {
    return Object.keys(rowSelection).map((rowId) => tableData[parseInt(rowId)]);
  }, [rowSelection, tableData]);

  useEffect(() => {
    setRowSelection({});
    setPageState({
      ...pageState,
      selectedTable: tableType,
    });
    if (tableType === "professional" || tableType === "cooperative")
      getAllOccurrences();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableType]);

  useEffect(() => {
    if (professional && tableType === "occurrences")
      getOportunities(professional._id);
  }, [professional, tableType]);

  useEffect(() => {
    getAllApplications();
  }, []);

  useEffect(() => {
    const savedState = sessionStorage.getItem("adminPageState");

    if (savedState) {
      try {
        const state = JSON.parse(savedState);

        setPageState((prev) => ({
          ...prev,
          filters: state.filters || [],
        }));

        if (state.pagination) {
          setPagination(state.pagination);
        }

        if (state.sorting) {
          setSorting(state.sorting);
        }

        if (state.columnVisibility) {
          setColumnVisibility({
            ...state.columnVisibility,
            _id: false,
          });
        }

        if (state.selectedProfessionalId) {
          setHighlightedRowId(state.selectedProfessionalId);
        }
      } catch (error) {
        console.error("Erro ao restaurar filtros:", error);
      }
    }
  }, []);

  useEffect(() => {
    const savedState = sessionStorage.getItem("adminPageState");

    if (!savedState || !tableData?.length || restoredStateRef.current) {
      return;
    }

    try {
      const state = JSON.parse(savedState);

      restoredStateRef.current = true;

      requestAnimationFrame(() => {
        if (tableSectionRef.current) {
          tableSectionRef.current.scrollTop = state.scrollY || 0;
        }

        sessionStorage.removeItem("adminPageState");
      });
    } catch (error) {
      console.error("Erro ao restaurar scroll:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  useEffect(() => {
    if (!highlightedRowId) return;

    const timeout = setTimeout(() => {
      setHighlightedRowId(null);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [highlightedRowId]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <MaterialReactTable
        enableStickyHeader
        tableInstanceRef={tableInstanceRef}
        state={{
          rowSelection,
          columnFilters: pageState.filters,
          pagination,
          columnVisibility,
          sorting,
        }}
        muiTableContainerProps={{
          sx: {
            maxHeight: "58vh",
            overflowY: "auto",
            overflowX: "auto",
          },
        }}
        muiTableBodyRowProps={({ row }) => ({
          sx: {
            transition: "background-color 0.75s ease",

            backgroundColor:
              row.original._id === highlightedRowId
                ? "#1044671e"
                : "transparent",
          },
        })}
        onRowSelectionChange={setRowSelection}
        onColumnFiltersChange={(updater) => {
          setPageState((prev) => {
            const newFilters =
              typeof updater === "function" ? updater(prev.filters) : updater;

            return {
              ...prev,
              filters: newFilters,
            };
          });
        }}
        onPaginationChange={setPagination}
        autoResetPageIndex={false}
        onSortingChange={setSorting}
        onColumnVisibilityChange={setColumnVisibility}
        enableRowSelection={tableType !== "occurrences"}
        enableRowActions
        displayColumnDefOptions={{
          "mrt-row-actions": {
            size: 10,
          },
        }}
        columns={
          tableType === "professional"
            ? professionalColumns
            : tableType === "cooperative"
              ? cooperativeColumns
              : tableType === "skill"
                ? skillColumns
                : occurrencesColumns
        }
        data={tableData}
        editingMode="modal"
        initialState={{
          columnVisibility: { _id: false },
          showColumnFilters: true,
          density: "comfortable",
          pagination: { pageSize: 10, pageIndex: 0 },
        }}
        localization={MRT_Localization_PT_BR}
        renderRowActions={({ row, table }) => (
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {tableType !== "professional" && (
              <>
                {tableType === "cooperative" && (
                  <>
                    <Tooltip
                      arrow
                      placement="right"
                      title="Visualizar Cooperado"
                    >
                      <IconButton
                        onClick={() => handleViewProfessionalClick(row)}
                      >
                        <PersonIcon />
                      </IconButton>
                    </Tooltip>
                    {!row.original.end_date && (
                      <Tooltip
                        arrow
                        placement="right"
                        title="Encerrar Vigência"
                      >
                        <IconButton onClick={() => handleEndClick(row)}>
                          <PersonRemove />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip arrow placement="bottom" title="Ver Ocorrências">
                      <IconButton
                        onClick={() => {
                          setOccurrenceBackTo("cooperative");
                          setTableType("occurrences");
                          // setTableData(row.original.occurrences);
                          setProfessional(row.original.professional);
                          getOccurrences(row.original.professional?._id);
                        }}
                      >
                        <TocIcon />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
                <Tooltip arrow placement="left" title="Excluir">
                  <IconButton
                    color="error"
                    onClick={
                      tableType === "cooperative"
                        ? () => handleDeleteRow(row)
                        : tableType === "skill"
                          ? () => handleDeleteSkill(row)
                          : () => handleDeleteOccurrence(row)
                    }
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </>
            )}
            <Tooltip arrow placement="right" title="Editar">
              <IconButton
                onClick={
                  tableType === "cooperative"
                    ? () => handleEditCooperativeClick(row)
                    : tableType === "professional"
                      ? () => handleEditProfessionalClick(row, table)
                      : tableType === "skill"
                        ? () => handleEditSkillClick(row)
                        : () => handleEditOccurrenceClick(row)
                }
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            {tableType === "professional" && (
              <>
                <Tooltip
                  arrow
                  placement="right"
                  title="Adicionar como Cooperado"
                >
                  <IconButton onClick={() => handleAddCooperativeClick(row)}>
                    <PersonAddIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow placement="bottom" title="Ver Ocorrências">
                  <IconButton
                    onClick={() => {
                      setOccurrenceBackTo("professional");
                      setTableType("occurrences");
                      // setTableData(row.original.occurrences);
                      setProfessional(row.original);
                      getOccurrences(row.original._id);
                    }}
                  >
                    <TocIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}

            {tableType === "occurrences" && (
              <Tooltip
                arrow
                placement="bottom"
                title="Ver documentos relacionados"
              >
                <IconButton onClick={() => handleViewOccurenceFilesClick(row)}>
                  <Article />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        )}
        renderTopToolbarCustomActions={() => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              padding: "8px",
              flexWrap: "wrap",
              alignItems: "start",
            }}
          >
            <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
              {tableType === "professional" ? null : (
                <>
                  {tableType === "occurrences" && (
                    <Tooltip arrow placement="right" title="Voltar">
                      <IconButton
                        disabled={occurenceIsGoingBack}
                        onClick={handleBackButton}
                      >
                        <ArrowBackIcon />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Button
                    disabled={occurenceIsGoingBack}
                    onClick={
                      tableType === "cooperative"
                        ? () => setCreateModalOpen(true)
                        : tableType === "skill"
                          ? handleCreateSkillClick
                          : handleCreateOccurrenceClick
                    }
                    variant="contained"
                    sx={{ backgroundColor: "#104467" }}
                  >
                    {`Adicionar ${
                      tableType === "cooperative"
                        ? "Novo Cooperado"
                        : tableType === "skill"
                          ? "Nova Habilidade"
                          : "Nova Ocorrência"
                    }`}
                  </Button>
                </>
              )}
              {tableType === "occurrences" && (
                <Button
                  sx={{
                    padding: 0,
                    margin: 0,
                    minWidth: "fit-content",
                    height: "fit-content",
                  }}
                  onClick={() => setProfessionalDocsModalOpen(true)}
                >
                  <ButtonText>{"Ver documentos do(a) profissional"}</ButtonText>
                </Button>
              )}
              {tableType === "skill" && (
                <Button
                  sx={{
                    padding: 0,
                    margin: 0,
                    minWidth: "fit-content",
                    height: "fit-content",
                  }}
                  disabled={isAnalyzing}
                  onClick={handleAnalyzeSkillsClick}
                >
                  <ButtonText>
                    {selectedRows.length > 0
                      ? `Fazer análise para (${selectedRows.length}) habilidades`
                      : "Fazer análise para todas as habilidades"}
                  </ButtonText>
                </Button>
              )}
              {tableType !== "skill" && tableType !== "occurrences" && (
                <>
                  <Button
                    sx={{
                      padding: 0,
                      margin: 0,
                      minWidth: "fit-content",
                      height: "fit-content",
                    }}
                    onClick={handleExportData}
                    startIcon={<FileDownloadIcon />}
                  >
                    <ButtonText>Exportar Dados</ButtonText>
                  </Button>
                  {/* <Button
                  sx={{
                    padding: 0,
                    margin: 0,
                    minWidth: "fit-content",
                    height: "fit-content",
                  }}
                  onClick={() => console.log(pagination)}
                >
                  <ButtonText>teste</ButtonText>
                </Button> */}
                  {tableType === "professional" && (
                    <Button
                      sx={{
                        padding: 0,
                        margin: 0,
                        minWidth: "fit-content",
                        height: "fit-content",
                      }}
                      onClick={handleDownloadCurriculums}
                      disabled={selectedRows.length < 1 || isDownloading}
                      startIcon={<Article />}
                    >
                      <ButtonText>Baixar curriculos</ButtonText>
                    </Button>
                  )}

                  <Button
                    sx={{
                      padding: 0,
                      margin: 0,
                      minWidth: "fit-content",
                      height: "fit-content",
                    }}
                    onClick={() => {
                      const selectedEmails = selectedRows.map((row) => {
                        if (tableType === "professional") return row.user.email;

                        const professionals = professionalData.find(
                          (item) => item._id === row.professional,
                        );

                        return professionals.user.email;
                      });
                      const to = encodeURIComponent(selectedEmails.join(";"));
                      const subject = encodeURIComponent("Assunto");
                      const body = encodeURIComponent("Mensagem");

                      const outlookWebUrl = `https://outlook.office.com/mail/deeplink/compose?to=${to}&subject=${subject}&body=${body}`;

                      window.open(outlookWebUrl, "_blank");
                    }}
                    disabled={selectedRows.length < 1}
                    startIcon={<EmailIcon />}
                  >
                    <ButtonText>Contato por E-mail</ButtonText>
                  </Button>
                  <Button
                    sx={{
                      padding: 0,
                      margin: 0,
                      minWidth: "fit-content",
                      height: "fit-content",
                    }}
                    onClick={() => {
                      const selectedNumber = selectedRows.map((row) => {
                        if (tableType === "professional")
                          return row.phone.replace(/\D/g, "");

                        const professional = professionalData.find(
                          (item) => item._id === row.professional,
                        );

                        return professional.phone.replace(/\D/g, "");
                      });
                      const whatsappLink = `https://wa.me/55${selectedNumber}`;
                      window.open(whatsappLink, "_blank");
                    }}
                    disabled={selectedRows.length !== 1}
                    startIcon={<WhatsAppIcon />}
                  >
                    <ButtonText>Contato por WhatsApp</ButtonText>
                  </Button>
                </>
              )}
            </div>
            {tableType === "occurrences" && professional && (
              <div style={{ marginTop: "15px" }}>
                <span>{`Ocorrências de ${professional.name}${professional.cpf ? " (" + professional.cpf + ")" : ""}`}</span>
              </div>
            )}
          </Box>
        )}
      />
      <CreateNewAccountModal
        columns={cooperativeColumns}
        open={createModalOpen}
        onClose={closeCreateCooperativeModal}
        onSubmit={handleCreateNewRow}
        professionalData={professionalData}
        professional={professional}
      />
      <EditCooperativeModal
        open={cooperativeEditModal}
        onClose={closeEditCooperativeModal}
        professionalData={professionalData}
        mode={cooperativeModalMode}
        cooperative={cooperative}
      />
      <EditSkillModal
        open={skillEditModal}
        onClose={closeEditSkillModal}
        mode={skillModalMode}
        skill={skill}
      />
      <ProfessionalOccurrencesModal
        open={ocurrencesModalOpen}
        onClose={handleCloseOcurrences}
        mode={occurrencesModalType}
        occurrence={occurrence}
        professional={professional}
        getOccurrences={getOccurrences}
      />
      <OccurrenceFilesModal
        open={occurrenceFilesModalOpen}
        occurrence={occurrenceFiles}
        onClose={handleCloseOcurrencesFiles}
      />
      <ProfessionalDocsModal
        open={professionalDocsModalOpen}
        onClose={closeProfessionalDocsModal}
        professional={professional}
      />
      <CreateNewBlankModal
        open={infoModalOpen}
        onClose={handleCloseMoreInfo}
        data={infoModal}
      />
      <FullScreenLoader fadeOut={!isAnalyzing} takeTime />
    </LocalizationProvider>
  );
};

const validateRequired = (value) => !!value.length;
